import React, { useEffect, useState } from "react";
import * as validationService from "../add-device-modal/validationService";
import { debug } from "../../utils";
import { connect } from "react-redux";

function SshUsernameField({ value, onChange, centralCredentialId, error, disabled }) {

    const [disableInput, setDisableValue] = useState(disabled)

    const ProcessData = async () => {
        if (centralCredentialId && centralCredentialId > 0) {
            validationService.cleanValidation('sshUsername');
            setDisableValue(true);
            onChange('');
        } 
        else {
            validationService.validateUsername(value, 'sshUsername');
            setDisableValue(false);
        }       
        return () => validationService.cleanValidation('sshUsername');
    }
    useEffect(() => {
        ProcessData();
        /* eslint-disable react-hooks/exhaustive-deps */

    }, [value, centralCredentialId])


    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="ssh_username">Username <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="ssh_username-key"
                    value={centralCredentialId ? '' : value}
                    disabled={disableInput}
                    onChange={disableInput ? null : event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("SshPaswordlessKeyField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.sshUsername,
    }
}

export default connect(mapStateToProps)(SshUsernameField);
